"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCenteredCtaButton = exports.CardCenteredTitleAndCtaButtonType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("./Card"));
var CardMedia_1 = require("./CardMedia");
var CardHeader_1 = __importDefault(require("./CardHeader"));
var Button_1 = __importStar(require("../button/Button"));
var BrowsingContext_1 = __importDefault(require("../../common/enums/BrowsingContext"));
var CardContent_1 = __importDefault(require("./CardContent"));
var CardCenteredTitleAndCtaButtonType;
(function (CardCenteredTitleAndCtaButtonType) {
    CardCenteredTitleAndCtaButtonType["FEATURED"] = "featured";
    CardCenteredTitleAndCtaButtonType["PRIMARY"] = "primary";
    CardCenteredTitleAndCtaButtonType["UTILITY"] = "utility";
})(CardCenteredTitleAndCtaButtonType = exports.CardCenteredTitleAndCtaButtonType || (exports.CardCenteredTitleAndCtaButtonType = {}));
var buttonTypeMap = (_a = {},
    _a[CardCenteredTitleAndCtaButtonType.FEATURED] = Button_1.ButtonType.FEATURED,
    _a[CardCenteredTitleAndCtaButtonType.PRIMARY] = Button_1.ButtonType.PRIMARY,
    _a[CardCenteredTitleAndCtaButtonType.UTILITY] = Button_1.ButtonType.UTILITY,
    _a);
var CardCenteredCtaButton = function (props) {
    var children = props.children, linkOptions = props.linkOptions, onClick = props.onClick, classes = props.classes, buttonType = props.buttonType, otherProps = __rest(props, ["children", "linkOptions", "onClick", "classes", "buttonType"]);
    if (linkOptions) {
        var _a = linkOptions.target, target = _a === void 0 ? BrowsingContext_1.default.SELF : _a, href = linkOptions.href;
        return (react_1.default.createElement("a", __assign({ className: getClassNames(linkOptions, classes), href: href.toString(), rel: "noopener noreferrer", target: target, onClick: onClick }, otherProps),
            react_1.default.createElement("span", { className: "fds-button-label" }, children)));
    }
    else {
        return (react_1.default.createElement(Button_1.default, __assign({ type: buttonTypeMap[buttonType], classes: classes, onClick: onClick }, otherProps), children));
    }
};
exports.CardCenteredCtaButton = CardCenteredCtaButton;
var CardCenteredTitleAndCta = function (props) {
    var children = props.children, titleStyle = props.titleStyle, headerText = props.headerText, buttonType = props.buttonType, classes = props.classes, onClick = props.onClick, buttonText = props.buttonText, featuredGraphic = props.featuredGraphic, otherProps = __rest(props, ["children", "titleStyle", "headerText", "buttonType", "classes", "onClick", "buttonText", "featuredGraphic"]);
    return (react_1.default.createElement(Card_1.default, __assign({ classes: classnames_1.default('fds-card-centered-title-and-cta', classes) }, otherProps),
        featuredGraphic,
        react_1.default.createElement(CardHeader_1.default, { titleStyle: titleStyle }, headerText),
        children /* eslint-disable-line @typescript-eslint/no-explicit-any */,
        react_1.default.createElement(CardContent_1.default, { classes: "fds-card-cta" },
            react_1.default.createElement(exports.CardCenteredCtaButton, { classes: classes, onClick: onClick, buttonType: buttonType }, buttonText))));
};
var getClassNames = function (_a, classes) {
    var disabled = _a.disabled;
    return classnames_1.default('fds-button', 'fds-button-small', {
        'is-disabled': disabled
    }, classes);
};
CardCenteredTitleAndCta.defaultProps = {
    buttonType: CardCenteredTitleAndCtaButtonType.FEATURED,
    mediaType: CardMedia_1.CardMediaType.IMAGE_DECORATIVE_VERTICAL
};
exports.default = CardCenteredTitleAndCta;
